






























import Vue, { PropType } from 'vue';
import { IABTest, IABTestModalProp } from '@/store/types';
import * as actions from '@/store/action-types';
import * as mutations from '@/store/mutation-types';

export default Vue.extend({
  name: 'ABTestRenameModal',
  data() {
    return {
      saving: false as boolean,
    };
  },
  props: {
    abTest: Object as PropType<IABTest>,
    show: {
      type: Boolean,
    },
  },
  methods: {
    async confirmRenameABTest() {
      this.saving = true;
      await this.$store.dispatch(actions.UPDATE_AB_TEST, {
        id: this.abTest._id,
        reload: true,
        data: {
          name: this.abTest.name,
        },
      });
      this.saving = false;
      this.$emit('close');
    },
  },
});
